import { Button, Dialog, DialogActions, Divider } from "@mui/material";
import { LoadingIndicator } from "../../../components/loading-indicator.component";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useAuthorize } from "../../../hooks/use-authorize";
import { UserPermissionName } from "../../../models/user-permission-name";
import { useSaveData } from "../../../hooks/useSaveData";
import { projectsApiKeyStore } from "../../../api/projects-api-key-store";
import { ReactHookForm } from "../../../components/hook-form/react-hook-form.component";
import { useReactHookForm } from "../../../hooks/useReactHookForm";

interface ApplyPricingListDialog {
    openDialog: boolean;
    pricingDetails: any;
    onSavePricing: () => void;
    onClosedDialog: () => void;
}
export const ApplyPricingListDialog = ({ openDialog, pricingDetails, onSavePricing, onClosedDialog }: ApplyPricingListDialog) => {

    const form = useReactHookForm({
            defaultValues: {
                projectID: pricingDetails?.projectID,
            pricingListID: pricingDetails?.pricingListID
            },
        });

    const { isLoading: isApplyPricingListLoading, mutateAsync: mutateApplyPricingListAsync } = useSaveData(projectsApiKeyStore.applyPricingListToProject());

    const handleSubmit = async (filtersData: any) => {
       const payload = {
            projectID: filtersData?.projectID,
            pricingListID: filtersData?.pricingListID
        }
        await mutateApplyPricingListAsync({ data: payload });
        onSavePricing();
        onClosedDialog();
    };

    const handleSubmitApplyPricingList = async () => {
      
    }

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={openDialog}
            className="modalpopup"
            title={'CONFIRM STATUS'}
        // onClose={closeDialog}
        >
            <ReactHookForm formName="PROJECT_APPLY_PRICING_FORM" onSubmit={handleSubmit} formContextProps={form}>
                <div>
                    <div style={{ padding: '25px 50px', textAlign: 'center' }}>
                        <LoadingIndicator isLoading={isApplyPricingListLoading} />
                        <div>
                            Are you sure you want to apply the selected Pricing List? <br />This will override the current Pricing List for this project.
                        </div>
                    </div>
                </div>
                <Divider />
                <DialogActions>
                    {isReadOnlyPermission && (
                        <Button style={{ maxWidth: '140px' }} size='small' type="button" variant="outlined" onClick={onClosedDialog}>
                            Cancel
                        </Button>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }} className="  ">
                        <button
                            className="btn btn-sm btn-primary btn-lightGrey"
                            style={{
                                backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                                color: isReadOnlyPermission ? 'black' : '#fff',
                                cursor: 'pointer', padding: 2, marginRight: 6
                            }}
                            disabled={isReadOnlyPermission}
                            onClick={onClosedDialog}
                            autoFocus
                        >
                            No
                        </button>

                        <button
                            className="btn btn-sm btn-primary  btn-delete"
                            style={{
                                backgroundColor: (isApplyPricingListLoading || isReadOnlyPermission) ? '#d7dbdd' : '#0000b5',
                                color: (isApplyPricingListLoading || isReadOnlyPermission) ? 'black' : '#fff',
                                cursor: 'pointer', padding: 2
                            }}
                            disabled={isApplyPricingListLoading || isReadOnlyPermission}
                            type="submit"
                            onClick={handleSubmitApplyPricingList}
                        >
                            Yes
                        </button>
                    </div>
                </DialogActions>
            </ReactHookForm>
        </Dialog>
    );
}